module.exports = __webpack_public_path__ + "media/assets/svgs/notifications-white-d241ed87ed299f82d03dbc3b5267a3fe.svg";